import { i18n } from "@/boot/i18n";

export const OPERATIONS = {
  equal: "equal",
  contains: "contains",
  differ: "differ",
  greater: "greater",
  greater_equal: "greater_equal",
  less: "less",
  less_equal: "less_equal",
  empty: "empty",
  not_empty: "not_empty"
};

export const OPERATIONS_DISPLAY = {
  [OPERATIONS.equal]: "segment.symbols.equal",
  [OPERATIONS.contains]: "segment.contains",
  [OPERATIONS.differ]: "segment.symbols.differ",
  [OPERATIONS.greater]: "segment.symbols.greater",
  [OPERATIONS.greater_equal]: "segment.symbols.greater_equal",
  [OPERATIONS.less]: "segment.symbols.less",
  [OPERATIONS.less_equal]: "segment.symbols.less_equal",
  [OPERATIONS.empty]: "segment.empty",
  [OPERATIONS.not_empty]: "segment.not_empty"
};

export const SEGMENT_TYPE = {
  CUSTOMER: 1,
  INTERACTION: 2,
  LOOP: 3
};

export const SEGMENT_COMPARATOR = {
  AND: 1,
  OR: 2
};

export const CONDITION_TYPES = {
  attribute: "ATTRIBUTE",
  question: "QUESTION"
};

export const CONDITION_OPTIONS = [
  {
    label: i18n.t("segment.attr"),
    type: CONDITION_TYPES.attribute
  },
  {
    label: i18n.t("segment.question"),
    type: CONDITION_TYPES.question
  }
];

export const ANSWER_DEFAULT_OPTION = { label: "", value: "" };

export const QUESTION_DEFAULT_OPTION = { label: "Selecione a pergunta", value: "" };

export const FILTER_OPTIONS = [
  {
    id: "segment.equal",
    label: i18n.t("segment.equal"),
    display: i18n.t(OPERATIONS_DISPLAY.equal),
    value: OPERATIONS.equal
  },
  {
    id: "segment.contains",
    label: i18n.t("segment.contains"),
    display: i18n.t(OPERATIONS_DISPLAY.contains),
    value: OPERATIONS.contains
  },
  {
    id: "segment.differ",
    label: i18n.t("segment.differ"),
    display: i18n.t(OPERATIONS_DISPLAY.differ),
    value: OPERATIONS.differ
  },
  {
    id: "segment.greater",
    label: i18n.t("segment.greater"),
    display: i18n.t(OPERATIONS_DISPLAY.greater),
    value: OPERATIONS.greater
  },
  {
    id: "segment.greater_equal",
    label: i18n.t("segment.greater_equal"),
    display: i18n.t(OPERATIONS_DISPLAY.greater_equal),
    value: OPERATIONS.greater_equal
  },
  {
    id: "segment.less",
    label: i18n.t("segment.less"),
    display: i18n.t(OPERATIONS_DISPLAY.less),
    value: OPERATIONS.less
  },
  {
    id: "segment.less_equal",
    label: i18n.t("segment.less_equal"),
    display: i18n.t(OPERATIONS_DISPLAY.less_equal),
    value: OPERATIONS.less_equal
  },
  {
    id: "segment.empty",
    label: i18n.t("segment.empty"),
    display: i18n.t(OPERATIONS_DISPLAY.empty),
    value: OPERATIONS.empty
  },
  {
    id: "segment.not_empty",
    label: i18n.t("segment.not_empty"),
    display: i18n.t(OPERATIONS_DISPLAY.not_empty),
    value: OPERATIONS.not_empty
  }
];
